<app-companies-nav [activeMenuItem]="'companies'"></app-companies-nav>
<form *ngIf="companyForm" [formGroup]="companyForm" (ngSubmit)="onSubmit(companyForm)" class="content-card">
  <mat-card class="form-card" style="max-width: 1200px;">
    <mat-card-header>
      <mat-card-title>
        <h5>Company</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>


      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="40">
          <ng-container *appHasRoles="['admin']">
            <div style="height: 100px;">
              <input #fileInput type="file" [style.display]="'none'" (change)="uploadImage($event)">
              <mat-icon *ngIf="!companyForm.value.logoUrl" class="logo-clear" (click)="fileInput.click()">add_a_photo
              </mat-icon>

              <img *ngIf="companyForm.value.logoUrl" class="logo" [src]="companyForm.value.logoUrl"
                   (click)="fileInput.click()">
              <mat-icon *ngIf="companyForm.value.logoUrl" class="button-icon" (click)="fileInput.click()" aria-label="Edit">
                edit </mat-icon>
              <mat-icon *ngIf="companyForm.value.logoUrl" class="button-icon" (click)="resetLogoInput() "
                        aria-label="Delete">delete</mat-icon>

            </div>

            <h3>Company Data</h3>

            <mat-form-field>
              <input matInput placeholder="Name" formControlName="name" maxlength="50" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Brand name" formControlName="brandName" maxlength="50" required>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Director job title DE" formControlName="directorJobTitle" maxlength="50">
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Director job title EN" formControlName="directorJobTitleEn" maxlength="50">
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Director first name" formControlName="directorFirstName" maxlength="50">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Director last name" formControlName="directorName" maxlength="50">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Phone" formControlName="phone" [imask]="phoneMask" [unmask]="true" minlength="10"
                     maxlength="15">
            </mat-form-field>
            <mat-form-field>
              <input matInput type="email" placeholder="Email" formControlName="email" maxlength="30" required email>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Website URL" formControlName="websiteUrl" maxlength="150">
            </mat-form-field>

            <mat-form-field>
              <input matInput type="email" placeholder="Support Email" formControlName="supportEmail" maxlength="30" email>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Support Phone" formControlName="supportPhone" [imask]="phoneMask" [unmask]="true" minlength="10"
                     maxlength="15">
            </mat-form-field>

            <mat-form-field>
              <mat-select placeholder="Country" formControlName="countryIsoCode" required>
                <mat-option *ngFor="let country of countries" [value]="country.isoCode">{{country.name}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="City" formControlName="city" maxlength="50">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Address" formControlName="address" maxlength="50" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Postcode" formControlName="postcode" maxlength="50">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="VAT reg nr" formControlName="vatRegNr" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="VAT rate" formControlName="vatRate" (keypress)="numberOnly($event)" maxlength="3"
                     required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Order URL {{orderURLHintText}}" formControlName="orderUrl"
                     maxlength="50">
              <mat-hint><a [routerLink]="orderUrlLink" style="text-decoration:none">Go to URL</a></mat-hint>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Brand Referral URL {{brandReferralURLHintText}}" formControlName="brandReferralCode"
                     maxlength="50">
              <mat-hint><a [routerLink]="brandReferralUrlLink" style="text-decoration:none">Go to URL</a></mat-hint>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Google Analytics Code UA-XXXXXXXXX-XX" formControlName="googleAnalyticsCode">
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Facebook Pixel ID" formControlName="facebookPixelId">
            </mat-form-field>

          </ng-container>

          <h3>Social Media</h3>

          <mat-form-field>
            <input matInput placeholder="Facebook URL" formControlName="facebookUrl" maxlength="100">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Instagram URL" formControlName="instagramUrl" maxlength="100">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="TikTok URL" formControlName="tikTokUrl" maxlength="100">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="YouTube URL" formControlName="youTubeUrl" maxlength="100">
          </mat-form-field>


        </div>
        <div fxFlex="40">

          <div style="height: 100px;">

          </div>

          <h3>B2B Invoicing</h3>

          <mat-form-field>
            <input matInput placeholder="Customer number" formControlName="customerNumber" maxlength="12" required>
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Fx Rate Margin" formControlName="fxRateMargin" maxlength="2" (keypress)="numberOnly($event)" required>
          </mat-form-field>

          <h3>Language for bulk orders</h3>

          <mat-form-field>
            <mat-select placeholder="Order language" formControlName="orderLanguage" required>
              <mat-option [value]="0">german</mat-option>
              <mat-option [value]="1">english</mat-option>
            </mat-select>
          </mat-form-field>

          <h3>Payments</h3>

          <mat-form-field>
            <input matInput placeholder="Bank Name" formControlName="bankName" maxlength="50">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Bank Sort Code" formControlName="bankSortCode" maxlength="50">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Bank Branch No" formControlName="bankBranchNo" maxlength="50">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Account No" formControlName="accountNo" maxlength="50">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="IBAN" formControlName="iban" maxlength="50">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="BIC" formControlName="bic" maxlength="50">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SWIFT" formControlName="swift" maxlength="50">
          </mat-form-field>

          <div class="payments">
            <mat-checkbox formControlName="voucherPaymentEnabled">Voucher Payment Enabled</mat-checkbox>
            <mat-checkbox formControlName="invoicePaymentEnabled">Invoice Payment Enabled</mat-checkbox>
            <mat-checkbox formControlName="sofortPaymentEnabled">Sofort Payment Enabled</mat-checkbox>
            <mat-checkbox formControlName="cashOnDeliveryPaymentEnabled">Cash on delivery Payment Enabled</mat-checkbox>
            <mat-checkbox formControlName="creditCardPaymentEnabled">Credit Card Payment Enabled</mat-checkbox>
            <div class="payment-method-alert "
                 [hidden]="(companyForm.value.voucherPaymentEnabled || companyForm.value.invoicePaymentEnabled || companyForm.value.sofortPaymentEnabled || companyForm.value.creditCardPaymentEnabled || companyForm.value.cashOnDeliveryPaymentEnabled)">
              Please select at least one payment method</div>
          </div>


          <ng-container *appHasRoles="['admin']">

            <h3>Misc</h3>
            <div fxLayout="column">
              <mat-checkbox formControlName="webIdForBulkOrdersEnabled">WebID for Bulk Orders Enabled</mat-checkbox>

              <mat-checkbox formControlName="directInvoicingEnabled">Direct Invoicing</mat-checkbox>
              <br />
              <small>Order Method</small><br />
              <mat-select placeholder="Order method" formControlName="orderMethod" required>
                <mat-option [value]="0">Disabled</mat-option>
                <mat-option [value]="1">Enabled</mat-option>
                <mat-option [value]="2">App only</mat-option>
              </mat-select>
              <br />
              <br />
              <mat-checkbox formControlName="active">Active</mat-checkbox>
            </div>

            <h3>🔮 Card Processor Enquiry</h3>
            <div fxLayout="column">
              <mat-checkbox formControlName="cardProcessorEnquiryEnabled">Enabled</mat-checkbox>
            </div>

            <h3>Partner Wallet</h3>
            <div fxLayout="column">
              <mat-checkbox formControlName="partnerWalletEnabled">Enabled</mat-checkbox>
            </div>

            <div style="width: 200px; margin-top: 15px; margin-bottom: 10px;">
            <mat-form-field>
              <input matInput placeholder="Partner Wallet Default Top-Up Fee" formControlName="partnerWalletDefaultLoadFee" maxlength="5" (keypress)="numberOnly($event)" required>
            </mat-form-field>
            </div>

            <h3>Multi-Wallet</h3>
            <div fxLayout="column">
              <mat-checkbox formControlName="canCreateWallets">Enabled</mat-checkbox>
            </div>

          </ng-container>
        </div>
      </div>


      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="40">
          <ng-container *appHasRoles="['admin']">
            <h3>Cards Image</h3>
            <div style="height: 100px;">
              <input #fileInputCardsImage type="file" [style.display]="'none'" (change)="uploadCardsImage($event)">
              <mat-icon *ngIf="!companyForm.value.cardsImageUrl" class="cardsImage-clear" (click)="fileInputCardsImage.click()">add_a_photo
              </mat-icon>

              <img *ngIf="companyForm.value.cardsImageUrl" class="logo" [src]="companyForm.value.cardsImageUrl"
                   (click)="fileInputCardsImage.click()">
              <mat-icon *ngIf="companyForm.value.cardsImageUrl" class="button-icon" (click)="fileInputCardsImage.click()" aria-label="Edit">
                edit </mat-icon>
              <mat-icon *ngIf="companyForm.value.cardsImageUrl" class="button-icon" (click)="resetCardsImageInput() "
                        aria-label="Delete">delete</mat-icon>

            </div>

          </ng-container>
        </div>

      </div>

    </mat-card-content>

    <mat-card-actions align="end">
      <span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span> &nbsp;
      <button mat-raised-button color="primary" type="submit" [disabled]="!companyForm.valid">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
